const OwalInputType = {
  TEXT: 'text',
  SELECT: 'select',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  PASSWORD: 'password',
  NUMBER: 'number',
  HIDDEN: 'hidden',
  URL: 'url',
  FILE: 'file',
  properties: {
    text: { description: 'text' },
    select: { description: 'select' },
    radio: { description: 'radio' },
    checkbox: { description: 'checkbox' },
    password: { description: 'password' },
    number: { description: 'number' },
    hidden: { description: 'hidden' },
    url: { description: 'url' },
    file: { description: 'file' },
  },
  rawValue (type) {
    return this.properties[type].description
  },
}

if (Object.freeze) {
  Object.freeze(OwalInputType)
}

export { OwalInputType }
